import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-12 pb-14 md:pt-16 md:pb-16 px-4 md:px-8 overflow-hidden bg-navy-900" data-id="element-190">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-191"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-193">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight text-glow" data-id="element-194">
            ¿Sientes Que El Dinero Se Te Escapa Sin Importar Cuánto Trabajes?
          </h1>

          <div className="max-w-4xl mx-auto border-l-4 border-gold pl-6 py-2 mb-12 text-left md:text-center md:border-l-0 md:border-t-4 md:pt-6 md:pl-0" data-id="element-195">
            <h2 className="text-xl md:text-2xl text-gray-300 italic font-serif" data-id="element-196">
              No es tu esfuerzo. No es el mercado. Es un programa mental
              instalado antes de que cumplieras 7 años... y hoy te voy a mostrar
              cómo desinstalarlo.
            </h2>
          </div>

          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto mb-12" data-id="element-197">
            <strong className="text-white font-semibold" data-id="element-198">
              Descubre el Sistema Integral de 7 Pasos
            </strong>{' '}
            que une Neurociencia, Espiritualidad y el Método 70/30 para Eliminar
            tus Bloqueos Financieros y Construir Abundancia Real — Comenzando
            Hoy
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-3xl mx-auto mb-16" data-id="element-199">
          <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-transparent to-transparent z-10" data-id="element-200"></div>
          <img src="https://cdn.magicpatterns.com/uploads/vGUofsxXsv3cikA8N37LjN/image-PV_ROMPE_EL_CODIGO_DEL_DINERO.png" alt="Rompe El Código Del Dinero" className="w-full h-auto rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] box-glow relative z-0" data-id="element-201" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center flex flex-col items-center" data-id="element-202">
          <div className="flex flex-col items-center gap-3 mb-8" data-id="element-203">
            <span className="inline-block bg-red-500/20 text-red-400 text-sm md:text-base font-bold px-4 py-1.5 rounded-full border border-red-500/30 tracking-wide" data-id="element-204">
              🔥 83% DE DESCUENTO
            </span>
            <div className="flex items-center justify-center gap-4" data-id="element-205">
              <span className="text-2xl md:text-3xl text-red-500 line-through font-bold opacity-80" data-id="element-206">
                $37 USD
              </span>
              <span className="text-4xl md:text-5xl text-gold font-bold" data-id="element-207">
                → $6.36 USD
              </span>
            </div>
          </div>

          <CTAButton href="https://vitalyforms.com/cart/48329378398428:1" className="w-full md:w-auto mb-4" data-id="element-208">
            SÍ, QUIERO ROMPER EL CÓDIGO DEL DINERO AHORA
          </CTAButton>

          <p className="text-sm md:text-base text-gray-400 italic" data-id="element-209">
            Una inversión menor que un café con leche… con impacto duradero en
            toda tu vida financiera
          </p>
        </motion.div>
      </div>
    </section>;
}